export enum EmailConnectedBannerVariant {
  Default = 'DEFAULT',
  NoParcelsMobile = 'NO_PARCELS_MOBILE',
  NoParcelsDesktop = 'NO_PARCELS_DESKTOP',
}
